export const GET_TAGS = "GET_TAGS";
export const CREATE_TAG = "CREATE_TAG";
export const DELETE_TAG = "DELETE_TAG";

export const getTags = (data = {}, op = "GET_TAGS") => ({
  type: GET_TAGS,
  payload: data,
  optype: op,
});

export const createTag = (data = {}, op = "CREATE_TAG") => ({
  type: CREATE_TAG,
  payload: data,
  optype: op,
});

export const deleteTag = (data = {}, op = "DELETE_TAG") => ({
  type: DELETE_TAG,
  payload: data,
  optype: op,
});
